import type { ReactNode } from 'react';
import { TopBar } from './TopBar';
import { NavSidebar } from './NavSidebar';
import { StatusBar } from './StatusBar';
import { PlatformTour } from './PlatformTour';
import { ActionNotice } from './ActionNotice';
import './shell.css';

export function Shell({ children }: { children: ReactNode }) {
  return (
    <div className="iris-shell">
      <TopBar />
      <div className="iris-shell-body">
        <NavSidebar />
        <main className="iris-shell-main">{children}</main>
      </div>
      <StatusBar />
      <ActionNotice />
      <PlatformTour />
    </div>
  );
}
